import routes from '@/config/routes';
import { v3Get, v3Post, v3Put } from './axios.instance.V3';
import { ApiResponse, IGetReferredPeoplePayload } from './types';
import { IReferralLastShown, ISendEmail } from '@/store/types';

const updateReferralModalLastShown = (payload: IReferralLastShown): ApiResponse =>
  v3Put(routes.backendUrl.referralProgram.updateReferralModalLastShown, payload);

const canShowReferralModal = (): ApiResponse => v3Get(`${routes.backendUrl.referralProgram.canShowReferralModal}`);

const fetchReferredPeopleList = (listType: string, payload: IGetReferredPeoplePayload): ApiResponse =>
  v3Post(`${routes.backendUrl.referralProgram.getRefferedPeopleList}/${listType}`, payload);

const fetchReferralMainPageData = (): ApiResponse =>
  v3Get(`${routes.backendUrl.referralProgram.getReferralMainPageData}`);

const updateReferralTermsConditions = (timestamp: string): ApiResponse =>
  v3Put(`${routes.backendUrl.referralProgram.updatereferralprogramterms}${timestamp}`);

const getActiveGigsList = (): ApiResponse => v3Get(`${routes.backendUrl.referralProgram.getActiveGigsList}`);
const getReferralLinkGig = (gigId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.referralProgram.getReferralLinkGig}/${gigId}`);

const updatereferralPaymentAlert = (timestamp: string): ApiResponse =>
  v3Put(`${routes.backendUrl.referralProgram.updatereferralpaymentAlert}${timestamp}`);

const sendReferralLinkEmail = (payload: ISendEmail): ApiResponse =>
  v3Post(routes.backendUrl.referralProgram.sendInvitationEmail, payload);

const sendReferralLinkSms = (payload: string): ApiResponse =>
  v3Post(routes.backendUrl.referralProgram.sendInvitationSms, payload);

export const referralProgramApis = {
  updateReferralModalLastShown,
  canShowReferralModal,
  fetchReferredPeopleList,
  fetchReferralMainPageData,
  updateReferralTermsConditions,
  getActiveGigsList,
  getReferralLinkGig,
  updatereferralPaymentAlert,
  sendReferralLinkEmail,
  sendReferralLinkSms,
};
